import { useQuery, UseQueryResult } from 'react-query';
import { CompanyDocuments } from '../../models/CompanyDocuments';
import { fetchCompanyFilings } from '../../services/companyFilings/companyFilings.service';
import { CompanyFilingsDto } from '../../services/dtos/companyFilings/companyFilings.dto';
import useFetchUserPermissions from '../permissions/useFetchUserPermissions';
import { queryKeys } from '../queryKeyFactory';
import { fetchAllDocuments } from './utils/fetchAllDocuments';

export type FilingsSortOption =
  | 'date'
  | 'type'
  | 'uploadedFile.originalFilename'
  | 'uploadedFile.fileSize'
  | 'createdAt'
  | 'updatedAt';

export interface SearchFilingsPayload {
  take: number;
  skip: number;
  source: string[];
  fileName?: string;
  status?: string;
  types?: number[];
  author?: string;
  dateFrom?: string;
  dateTo?: string;
  sort?: FilingsSortOption;
  sortDesc: boolean;
}

export default (
  companyId: string,
  payload: SearchFilingsPayload,
  enabled = true
): UseQueryResult<CompanyDocuments<CompanyFilingsDto>, Error> => {
  const { data: userPermissions } = useFetchUserPermissions();

  return useQuery<CompanyDocuments<CompanyFilingsDto>, Error>(
    queryKeys.fetchFilings.allByIssuer(companyId, payload, enabled),
    async () => {
      if (!userPermissions?.permissions.includes('ui:show-company-docs')) {
        return {
          totalResults: 0,
          results: [],
        };
      }

      const res = await fetchAllDocuments<CompanyFilingsDto, SearchFilingsPayload & { companyId: string }>(
        fetchCompanyFilings,
        {
          companyId,
          ...payload,
          status: 'published',
        }
      );

      return {
        totalResults: res.totalResults,
        results: res.results.map((item) => [[item]]),
      };
    },
    { enabled: enabled && !Number.isNaN(Number(companyId)), retry: false }
  );
};
